<template>
</template>

<script>
	export default {
		
		created() {
			var select_id = this.$route.params.id
			localStorage.setItem('select_id', select_id)
			
			this.$router.push('/group-center')
			
			//window.location.href = '/group-center'
		}
	}
</script>

<style>
</style>
